// Data
import data from "assets/data/data.json";

// Styles
import { Container } from "assets/styles/Layout/Layout.styled";
import {
  HomePageMainTop,
  HomePageMainIcons,
  HomePageMainSection,
  HomePageMainRow,
  HomePageMainCol,
} from "./HomePageMain";
import { Button } from "assets/styles/Elements/Button.styled";

// Components
import BoxContent from "components/Elements/BoxContent/index";

// Images
import doctor from "assets/images/doctor.webp";
import sectionbg from "assets/images/seniorcare.jpg";

// Interface
import { HomePageIcons } from "interface/HomePageMain";
import { useTheme } from "styled-components";

function HomePage(): JSX.Element {
  const homePageContent = () => {
    let homePageContent: any;
    data.routes.map((route) =>
      route.path === "/" ? (homePageContent = route.content) : null
    );
    return homePageContent;
  };

  return (
    <>
      <Container margin={80}>
        <HomePageMainTop>
          <img src={doctor} alt="doctor Noer" />
          <h2>{homePageContent().mainTopHeading}</h2>
          <Button>Meer over Broeder Julio</Button>
        </HomePageMainTop>

        <HomePageMainIcons>
          {homePageContent().iconContent.map(
            (icon: HomePageIcons, idx: number) => (
              <BoxContent
                key={idx}
                src={icon.image}
                heading={icon.heading}
                content={icon.content}
              />
            )
          )}
        </HomePageMainIcons>
      </Container>

      <HomePageMainSection bgImage={sectionbg} sectionHeight={88}>
        <div>
          <h2>{homePageContent().mainSectionHeading}</h2>
          <p>{homePageContent().mainSectionParagraph}</p>
        </div>
      </HomePageMainSection>

      <Container margin={20}>
        <HomePageMainRow>
          <HomePageMainCol border={`6px solid ${useTheme().colors.primaryLight}`} paddingLeft={"1rem"}>
            <h2>{homePageContent().mainCol1.heading}</h2>
            <p>{homePageContent().mainCol1.paragraph}</p>
            <Button>Meer info</Button>
          </HomePageMainCol>
          <HomePageMainCol bgColor={useTheme().colors.primaryLight}>
            <h2>{homePageContent().mainCol2.heading}</h2>
            <p>{homePageContent().mainCol2.paragraph}</p>
          </HomePageMainCol>
        </HomePageMainRow>
      </Container>
    </>
  );
}

export default HomePage;
